module.exports = __webpack_public_path__ + "static/media/imagebox_4.565d8326.jpg";